import { type ComponentProps } from 'react'

import { LinkOutbound } from '@/components/common/Link'
import { type DistributiveOmit, RELATED_URLS } from '@/defs/misc'

import styles from './SupportUsMessage.module.scss'

type Props = {
  link?: DistributiveOmit<ComponentProps<typeof LinkOutbound>, 'href'>
  message?: string
}

export const SupportUsMessage = ({
  link,
  message = 'Please consider supporting us on Patreon to remove ads for only $2/month.',
}: Props) => (
  <LinkOutbound
    className={styles.container}
    href={RELATED_URLS.patreon}
    utm={{ medium: 'please_support_us' }}
    {...link}
  >
    {message}
  </LinkOutbound>
)
